/* eslint-disable */
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
/* eslint-enable */
import polyfills from './polyfills';
import accMenu from './modules/menu-accordion';
import headerToggler from './modules/header-toggler';
import popupToggler from './modules/popup-toggler';
import searchToggler from './modules/search-toggler';
import slickInit from './modules/slick-init';
import equivalent from './modules/equal-height';
import stickyNav from './modules/nav-sticky';
import counterJs from './modules/counter';
import classRegistrationBtn from './modules/class-registration-btn';
import feesblock from './modules/fees-block';
import stats from './modules/stats';

(() => {
  polyfills();
  headerToggler();
  popupToggler();
  searchToggler();
  slickInit($);
  equivalent($);
  stickyNav();
  accMenu();
  counterJs();
  classRegistrationBtn();
  feesblock();
  stats();
})();

// You can use dynamic import if you want
// For example
//
// document.addEventListener('click', async () => {
//   const { selectAll } = await import('./helpers')
//   console.log(selectAll('a'))
// })
